export interface CXoneConfiguration{
    acdApiBaseUri: string;
    isUserHub:boolean;
    wfmUri?:string;
    notificationUri?:string;
    userHubBaseUrl?:string;
  }